import {useEffect} from "react";

/*
 * Having an empty dependency array is valid for when we only want to run a function on mount.
 * This function exists so that the lint warning only needs to be ignored in one place.
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = (fun) => useEffect(fun, []);

export default useMountEffect;